import Enum from './Domain'

class TypeSize extends Enum { }

TypeSize.initEnum(['NONE', 'SMALL', 'MEDIUM', 'LARGE'])

export default TypeSize
